import * as React from 'react';
import {
  Box,
  ButtonGroup,
  Container,
  IconButton,
  Stack,
  Text,
} from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import { IoLogoFacebook, IoLogoWhatsapp, IoLogoYoutube } from 'react-icons/io5';
import { graphql, useStaticQuery } from 'gatsby';

const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          googleMapsUrl
          whatsappUrl
          facebookUrl
          youtubeUrl
        }
      }
    }
  `);

  return data.site.siteMetadata;
};

export const Footer = () => {
  const { whatsappUrl, facebookUrl, youtubeUrl } = useSiteMetadata();
  return (
    <Box
      bg="white"
      color="text.muted"
      borderTop={1}
      borderStyle="solid"
      borderColor="gray.200"
    >
      <Container
        as={Stack}
        py="4"
        direction={{ base: 'column', md: 'row' }}
        spacing="4"
        justify={{ base: 'center', md: 'space-between' }}
        align="center"
      >
        <Stack
          direction={{ base: 'column', md: 'row' }}
          spacing="4"
          align="center"
        >
          <StaticImage src="../images/logo.png" alt="Yaisana" height={56} />
          <Text textAlign="center">
            © {new Date().getFullYear()} Yaisana Digital Pvt Ltd. All rights
            reserved
          </Text>
        </Stack>
        <Stack direction="row" spacing="6">
          <ButtonGroup variant="ghost">
            <IconButton
              as="a"
              href={whatsappUrl}
              aria-label="Whatsapp"
              icon={<IoLogoWhatsapp fontSize="1.25rem" />}
            />
            <IconButton
              as="a"
              href={facebookUrl}
              aria-label="Facebook"
              icon={<IoLogoFacebook fontSize="1.25rem" />}
            />
            <IconButton
              as="a"
              href={youtubeUrl}
              aria-label="YouTube"
              icon={<IoLogoYoutube fontSize="1.25rem" />}
            />
          </ButtonGroup>
        </Stack>
      </Container>
    </Box>
  );
};
